module.exports = __webpack_public_path__ + "img/client-img1.848d2eb7.jpg";